import { paths } from '@/app/routes/paths';

export type NavigationItem = {
  readonly label: string;
  readonly href: string;
};

export type NavigationGroup = {
  readonly title: string;
  readonly items: readonly NavigationItem[];
  readonly headingClassName?: string;
};

export const siteNavigationLinks = {
  about: {
    label: '病院案内',
    href: paths.about.root,
  },
  firstVisiting: {
    label: '初めての患者様',
    href: paths.firstVisiting,
  },
  info: {
    label: '診療案内',
    href: paths.info,
  },
  appointment: {
    label: '予約のご案内',
    href: paths.appointment,
  },
  kids: {
    label: '小児歯科',
    href: paths.kids,
  },
  access: {
    label: '交通案内',
    href: paths.access,
  },
  cerec: {
    label: 'セレック',
    href: paths.cerec,
  },
  orthodontic: {
    label: '矯正歯科',
    href: paths.orthodontic,
  },
  whitening: {
    label: 'ホワイトニング',
    href: paths.whitening,
  },
  periodontal: {
    label: '歯周病治療',
    href: paths.periodontal,
  },
  dentures: {
    label: '入れ歯',
    href: paths.dentures,
  },
  price: {
    label: '自由診療料金表',
    href: paths.price,
  },
  recruitment: {
    label: '採用情報',
    href: paths.recruitment.root,
  },
  facilityStandards: {
    label: '厚生労働省への届出',
    href: paths.facilityStandards,
  },
  childcareService: {
    label: '託児サービス',
    href: paths.childcareService,
  },
  paymentMachine: {
    label: '自動精算機',
    href: paths.paymentMachine,
  },
} as const satisfies Record<string, NavigationItem>;

export const headerNavigationItems = [
  siteNavigationLinks.about,
  siteNavigationLinks.firstVisiting,
  siteNavigationLinks.info,
  siteNavigationLinks.appointment,
  siteNavigationLinks.kids,
  siteNavigationLinks.access,
] as const;

export const footerNavigationGroups = [
  {
    title: '診療案内',
    items: [
      siteNavigationLinks.cerec,
      siteNavigationLinks.kids,
      siteNavigationLinks.orthodontic,
      siteNavigationLinks.whitening,
      siteNavigationLinks.periodontal,
      siteNavigationLinks.dentures,
      siteNavigationLinks.price,
    ],
  },
  {
    title: '病院情報',
    headingClassName: 'text-gray-200',
    items: [
      siteNavigationLinks.about,
      siteNavigationLinks.access,
      siteNavigationLinks.recruitment,
      siteNavigationLinks.facilityStandards,
    ],
  },
  {
    title: '各種サービス',
    headingClassName: 'text-gray-200',
    items: [siteNavigationLinks.childcareService, siteNavigationLinks.paymentMachine],
  },
] as const satisfies readonly NavigationGroup[];
